import { faCopy, faMinus, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Badge } from 'primereact/badge'

import './DynamicFieldButtons.scss'
import clsx from 'clsx'
import { Tooltip } from 'primereact/tooltip'

const DynamicFieldButtons = props => {
  const {
    onAddDynamicFieldMultiple,
    onRemoveDynamicFieldMultiple,
    rowLength,
    rowIndex,
    className,
    addButtonClassName,
    removeButtonClassName,
    onCopyDynamicFieldValue,
    fieldName,
    certGroupIndex,
  } = props
  return (
    <div className={clsx('ul-grid__column', className ?? '-x30')}>
      {rowLength > 1 && (
        <span
          className={clsx('cursor-pointer dynamic-fd-add-remove-btn-span', removeButtonClassName)}
          onClick={onRemoveDynamicFieldMultiple}
        >
          <Badge
            value={<FontAwesomeIcon icon={faMinus} />}
            style={{
              backgroundColor: 'transparent',
              color: '#ff5050',
              border: 'solid 1px #ff5050',
              borderRadius: '50%',
            }}
            size="large"
          ></Badge>
        </span>
      )}

      {rowLength === rowIndex + 1 && (
        <span
          className={clsx('cursor-pointer dynamic-fd-add-remove-btn-span', addButtonClassName)}
          onClick={onAddDynamicFieldMultiple}
        >
          <Badge
            value={<FontAwesomeIcon icon={faPlus} />}
            style={{
              backgroundColor: 'transparent',
              color: '#94beec',
              border: 'solid 1px #94beec',
              borderRadius: '50%',
            }}
            size="large"
          ></Badge>
        </span>
      )}

      {certGroupIndex !== 1 && (
        <span className={clsx('dynamic-fd-add-copy-btn-span', addButtonClassName)}>
          <FontAwesomeIcon
            className="add-copy-fa"
            id={`dynamic-fd-add-copy-btn-span-${fieldName}-${rowIndex}`}
            icon={faCopy}
            style={{
              color: '#3280d6',
              width: '30px',
              height: '30px',
            }}
            onClick={onCopyDynamicFieldValue}
          />
          <Tooltip
            target={`#dynamic-fd-add-copy-btn-span-${fieldName}-${rowIndex}`}
            position="right"
          >
            Copy
          </Tooltip>
        </span>
      )}
    </div>
  )
}

export default DynamicFieldButtons
